import { IdentifierDTO } from '@zazume/zzm-base';
import { DateVO } from '@zazume/zzm-utils';

import { BureauReportOperation } from '../bureauReport/BureauReportOperation';
import type { BureauDataProvider, BureauReportStatus } from '../bureauReport/types';

interface Fields {
  _id: IdentifierDTO;
  createdAt: DateVO;
  status: BureauReportStatus;
  provider: BureauDataProvider;
  operation?: BureauReportOperation;
  validatedAt?: DateVO;
}

export class NonPaymentBureauReport {
  _id: IdentifierDTO;
  createdAt: DateVO;
  status: BureauReportStatus;
  provider: BureauDataProvider;
  operation?: BureauReportOperation;
  validatedAt?: DateVO;

  constructor(params: Fields) {
    this._id = params._id;
    this.createdAt = params.createdAt;
    this.status = params.status;
    this.provider = params.provider;
    this.operation = params.operation;
    this.validatedAt = params.validatedAt;
  }

  static fromRaw(raw: any): NonPaymentBureauReport {
    return new NonPaymentBureauReport({
      ...raw,
      operation: raw.operation ? BureauReportOperation.fromRaw(raw.operation) : undefined,
      createdAt: DateVO.fromPrimitive(raw.createdAt),
      validatedAt: raw.validatedAt ? DateVO.fromPrimitive(raw.validatedAt) : undefined
    });
  }
}
